module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrows-v-813c155196fd2a4754735446a4b0d544.svg";